import { useMutation } from '@tanstack/react-query'

import { syncResourceComponentStatusesFromMonolith } from '@/features/resource/endpoints/resources'

export function useSyncResourceComponentStatusesMutation() {
  const { mutateAsync, ...mutationResult } = useMutation({
    mutationFn: (resourceId: string) => syncResourceComponentStatusesFromMonolith(resourceId),
  })

  return {
    syncResourceComponentStatuses: mutateAsync,
    ...mutationResult,
  }
}
